// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root */
.leads-root-min {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: "DM Sans", sans-serif;
  margin-top: 30px;
}

/* Card */
.lead-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

/* Header row — clickable */
.lead-row {
  display: grid;
  grid-template-columns: 44px 120px 160px 200px 1fr 128px;
  gap: 16px;
  align-items: center;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
}

.lead-col {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.lead-col.action {
  justify-content: flex-end;
}

.lead-col.select {
  justify-content: center;
  background: transparent;
  border: none;
  box-shadow: none;
}

.lead-col.select .MuiCheckbox-root {
  background: transparent;
  border: none;
  box-shadow: none;
}

.lead-select-all-row {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  gap: 4px;
  min-height: 44px;
  box-sizing: border-box;
}

.lead-select-all-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
}

.lead-bulk-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.lead-bulk-count {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
}

.lead-export-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #5616ea;
  color: #fff;
  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}
.lead-export-button:hover:not(:disabled) {
  background-color: #4a14d6;
  transform: translateY(-1px);
}
.lead-export-button:disabled {
  background-color: #c7bdf0;
  opacity: 0.55;
  cursor: not-allowed;
}
.lead-export-icon {
  font-size: 12px;
}

.lead-bulk-delete-button {
  padding: 5px 10px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  color: #474747;
  will-change: transform;
  backface-visibility: hidden;
}

.lead-bulk-delete-button:hover {
  background-color: #ededed;
  transform: scale(1.1);
}

.lead-bulk-delete-button:disabled {
  background-color: #ededed;
  transform: scale(1.0);
  cursor: not-allowed;
}

.lead-bulk-delete-muted {
  color: #c0c0c0;
  border-color: #e8e8e8;
}

/* Actions area */
.actions-wrap {
  display: inline-flex;
  gap: 12px;
}

/* Status badge */
.badge {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 999px;
  border: 1px solid #eaeaea;
  background: #fafafa;
  color: #444;
}
.badge svg { font-size: 10px; }
.badge.unread {
  background: #fff7f7;
  border-color: #ffd9d9;
  color: #c83b3b;
}
.badge.unread svg { color: #ff6b6b; }
.badge.read {
  background: #f3fff7;
  border-color: #c8f1d6;
  color: #187a49;
}
.badge.read svg { color: #2ecc71; }

/* Date + bot look */
.date {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  color: #3f3f3f;
  font-weight: 500;
}
.date-icon { color: #5616ea; margin-bottom: 2px; }

.lead-chat-thread .chat-date-separator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 4px 0;
  width: 100%;
  box-sizing: border-box;
}

.lead-chat-thread .chat-date-separator:first-child {
  margin-top: 0;
  padding-top: 0;
}

.lead-chat-thread .chat-date-separator-text {
  background-color: #f0f0f0;
  color: #8e8e8e;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 12px;
  transition: opacity 0.15s ease;
  opacity: 1;
}

.bot-pill {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  min-width: 90px;
  text-align: center;
}

/* lead forwarded during an Agent-Studio test conversation */
.lead-test-pill {
  display: inline-block;
  margin-left: 6px;
  padding: 5px 8px;
  border-radius: 8px;
  background: #fff8f2;
  border: 1px solid #f0c8a8;
  color: #9a4b00;
  font-size: 11px;
  font-weight: 700;
  vertical-align: middle;
}

/* Param chips */
.lead-param-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
}
.param-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #ececec;
  background: #fafafa;
  color: #4a4a4a;
  font-size: 12px;
}
.param-chip-icon {
  color: #5616ea;
  font-size: 12px;
}
.param-chip-key { font-weight: 600; }
.param-chip-sep { color: #b7b7b7; }
.param-chip-val { color: #2b2b2b; text-decoration: none; }

/* Chevron */
.chevron-btn {
  padding: 5px 10px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  color: #474747;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;
  will-change: transform;
  backface-visibility: hidden;
}
.chevron-btn:hover {
  background-color: #ededed;
  transform: scale(1.1);
}

.chevron-btn svg {
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.chevron-btn.expanded svg {
  transform: rotate(180deg);
}

/* Trash */
.trash-btn {
  padding: 5px 10px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  color: #474747;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;
  will-change: transform;
  backface-visibility: hidden;
}
.trash-btn:hover {
  background-color: #ededed;
  transform: scale(1.1);
}

/* ===== Mirrored chat history (from chatHistoryOverview) ===== */
.lead-chat-thread {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid #eeeeee;
  padding: 14px 16px 16px;
  animation: fadeIn .18s ease;
}
.chat-message {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.chat-message:first-child { margin-top: 0; }
.chat-message:last-child { margin-bottom: 0; }
.chat-message.assistant-message { align-items: flex-start; }
.chat-message.user-history-message {
  align-items: flex-end;
  gap: 6px;
}

.lead-chat-thread .user-message-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.lead-chat-thread .user-message-body {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lead-chat-thread .message-bubble-history {
  padding: 6px 10px !important;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.4;
  word-wrap: break-word;
  background-color: #efefef;
  color: #262626;
}

.lead-chat-thread .user-history-message .message-bubble-history {
  background-color: #5616ea;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.lead-chat-thread .assistant-message .message-bubble-history {
  background: #efefef;
  color: #262626;
  font-size: 16px;
  line-height: 1.5;
  padding: 6px 10px !important;
  border-radius: 12px 12px 12px 4px;
  max-width: 70%;
}

.lead-chat-thread .assistant-message .message-bubble-history p {
  margin: 0 0 .9em;
}

.lead-chat-thread .assistant-message .message-bubble-history h1,
.lead-chat-thread .assistant-message .message-bubble-history h2,
.lead-chat-thread .assistant-message .message-bubble-history h3,
.lead-chat-thread .assistant-message .message-bubble-history h4,
.lead-chat-thread .assistant-message .message-bubble-history h5,
.lead-chat-thread .assistant-message .message-bubble-history h6 {
  font-size: 1em;
  line-height: inherit;
  margin: 0 0 .9em;
}

.lead-chat-thread .assistant-message .message-bubble-history ul,
.lead-chat-thread .assistant-message .message-bubble-history ol {
  margin: .9em 0;
  padding-left: 1.25em;
}

.lead-chat-thread .assistant-message .message-bubble-history li {
  margin: .25em 0;
}

.lead-chat-thread .assistant-message .message-bubble-history table {
  margin: .9em 0;
}

.lead-chat-thread .assistant-message .message-bubble-history > :first-child {
  margin-top: 0;
  padding-top: 0;
}

.lead-chat-thread .assistant-message .message-bubble-history > :last-child {
  margin-bottom: 0;
  padding-top: 0;
}

.lead-chat-thread .assistant-message .message-bubble-history a {
  color: #5616ea;
  font-weight: 500;
  text-decoration: underline;
}

.lead-chat-thread .user-history-message .message-bubble-history a {
  color: #fff;
}

.lead-chat-thread .message-bubble-history p {
  margin: 0;
}

.lead-chat-thread .message-time {
  font-size: 11px;
  color: #8e8e8e;
  padding: 0px;
  margin-bottom: 4px;
  margin-top: 4px;
}

.lead-chat-thread .assistant-message .message-time {
  align-self: flex-start;
}

.lead-chat-thread .user-history-message .message-time {
  align-self: flex-end;
}

.message-bubble {
  padding: 10px 15px;
  border-radius: 10px;
  max-width: 70%;
  font-size: 16px;
  line-height: 1.5;
  word-wrap: break-word;
  background-color: #f6f6f6;
  color: #333;
}
.message-bubble > *:first-child { margin-top: 0; }
.message-bubble > *:last-child { margin-bottom: 0; }
.user-history-message .message-bubble {
  background-color: #5616ea;
  color: #fafafa;
}
.user-history-message .message-bubble a { color: #fafafa; }

.message-bubble a {
  color: #5616ea;
  text-decoration: underline;
}
.message-bubble table {
  border-collapse: separate;
  border-spacing: 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  overflow: auto;
  font-size: 14px;
}
.message-bubble th,
.message-bubble td {
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: .35rem .50rem;
  text-align: left;
}
.message-bubble th {
  color: #000000;
  background-color: rgba(0, 0, 0, 0.06);
  padding: .5rem .50rem;
}
.message-bubble th:last-child { border-right: 1px solid rgba(0, 0, 0, 0.08); }
.message-bubble th { border-bottom: none; }
.message-bubble td {
  border-bottom: 0px solid rgba(0, 0, 0, 0.08);
  border-right: 0px solid rgba(0, 0, 0, 0.08);
}
.message-bubble td:last-child { border-right: 1px solid rgba(0, 0, 0, 0.08); }
.message-bubble tr:first-child th:first-child { border-top-left-radius: 8px; }
.message-bubble tr:first-child th:last-child { border-top-right-radius: 8px; }
.message-bubble tr:last-child td:first-child { border-bottom-left-radius: 8px; }
.message-bubble tr:last-child td:last-child { border-bottom-right-radius: 8px; }
.message-bubble tr:last-child td { border-bottom: 1px solid rgba(0,0,0,0.08); }

/* Empty + Loading */
.leads-empty-min { padding: 16px 0; }
.empty-card {
  border: 1px dashed #dcdcdc;
  background: #fff;
  border-radius: 14px;
  padding: 24px;
  text-align: center;
  color: #555;
}

.lead-chat-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  color: #5616ea;
  font-size: 14px;
}

.lead-chat-empty {
  padding: 24px;
  text-align: center;
  color: #888;
  font-size: 14px;
}

.lead-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  padding: 6px 0 0;
}

.lead-pagination-summary {
  color: #666;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.lead-pagination-controls {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.lead-page-button {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #ece7ff;
  border-radius: 8px;
  background: #fff;
  color: #742de3;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(94, 27, 255, 0.05);
  transition: background-color 0.25s ease, border-color 0.25s ease, color 0.25s ease, box-shadow 0.3s ease, transform 0.3s ease;
}

.lead-page-button:hover:not(:disabled) {
  background: #f9f6ff;
  border-color: #d9ccff;
  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.12);
  transform: translateY(-2px);
}

.lead-page-button.active {
  background: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);
  border-color: #5e1bff;
  color: #fff;
  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.16);
}

.lead-page-button.active:hover {
  background: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);
  border-color: #5e1bff;
  color: #fff;
  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.16);
  transform: none;
}

.lead-page-button:disabled {
  background: #f7f7f7;
  border-color: #eeeeee;
  color: #c4c4c4;
  box-shadow: none;
  cursor: not-allowed;
}

.lead-page-arrow {
  width: 36px;
  padding: 0;
}

.lead-page-ellipsis {
  min-width: 28px;
  color: #9b8bc8;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}

@keyframes fadeIn {
  from { opacity: 0 } to { opacity: 1 }
}

/* Responsive */
@media (max-width: 1100px) {
  .lead-row {
    grid-template-columns: 40px 110px 140px 180px 1fr 116px;
  }
}
@media (max-width: 760px) {
  .lead-row {
    grid-template-columns: 36px minmax(0, 1fr) auto;
    grid-template-rows: auto auto auto auto;
    gap: 10px;
    align-items: start;
  }

  .lead-col.select {
    grid-column: 1;
    grid-row: 1;
    justify-content: center;
    align-items: center;
  }
  .lead-col.status { grid-column: 2; grid-row: 1; }
  .lead-col.when {
    grid-column: 1 / -1;
    grid-row: 3;
    justify-content: flex-start;
    align-items: center;
  }
  .lead-col.bot {
    grid-column: 1 / -1;
    grid-row: 2;
    justify-content: flex-start;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
  }
  .lead-col.action {
    grid-column: 3;
    grid-row: 1;
    justify-content: flex-end;
    align-items: flex-start;
    padding-left: 0;
    padding-right: 6px;
  }

  .lead-col.params {
    grid-column: 1 / -1;
    grid-row: 4;
    padding-left: 0;
    padding-right: 0;
    min-width: 0;
  }

  .lead-param-chips {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .param-chip {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    justify-content: flex-start;
    align-self: stretch;
    margin: 0;
    word-break: break-word;
  }

  .actions-wrap {
    width: 100%;
    justify-content: flex-end;
    gap: 8px;
    padding-right: 0;
  }

  .lead-pagination {
    gap: 12px;
  }

  .lead-pagination-summary {
    width: 100%;
    text-align: center;
  }

  .lead-pagination-controls {
    width: 100%;
    gap: 6px;
  }

  .lead-page-button {
    min-width: 34px;
    height: 34px;
    padding: 0 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/leads.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gEAAgE;EAChE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,4FAA4F;EAC5F,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qIAAqI;EACrI,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA,aAAa,eAAe,EAAE;AAC9B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,oBAAoB,cAAc,EAAE;AACpC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,kBAAkB,cAAc,EAAE;;AAElC,oBAAoB;AACpB;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,aAAa,cAAc,EAAE,kBAAkB,EAAE;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE,qBAAqB,EAAE;;AAEzD,YAAY;AACZ;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qIAAqI;EACrI,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qIAAqI;EACrI,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA,4BAA4B,aAAa,EAAE;AAC3C,2BAA2B,gBAAgB,EAAE;AAC7C,kCAAkC,uBAAuB,EAAE;AAC3D;EACE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA,kCAAkC,aAAa,EAAE;AACjD,iCAAiC,gBAAgB,EAAE;AACnD;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,0CAA0C,cAAc,EAAE;;AAE1D;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qCAAqC;EACrC,qBAAqB;AACvB;AACA,gCAAgC,2CAA2C,EAAE;AAC7E,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;AACA,gCAAgC,2CAA2C,EAAE;AAC7E,gDAAgD,2BAA2B,EAAE;AAC7E,+CAA+C,4BAA4B,EAAE;AAC7E,+CAA+C,8BAA8B,EAAE;AAC/E,8CAA8C,+BAA+B,EAAE;AAC/E,mCAAmC,yCAAyC,EAAE;;AAE9E,oBAAoB;AACpB,mBAAmB,eAAe,EAAE;AACpC;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;EAC9C,6HAA6H;AAC/H;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,WAAW;EACX,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO,WAAW,EAAE,KAAK,WAAW;AACtC;;AAEA,eAAe;AACf;EACE;IACE,uDAAuD;EACzD;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,uCAAuC;IACvC,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;EACA,mBAAmB,cAAc,EAAE,WAAW,EAAE;EAChD;IACE,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":["/* Root */\r\n.leads-root-min {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  margin-top: 30px;\r\n}\r\n\r\n/* Card */\r\n.lead-card {\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* Header row — clickable */\r\n.lead-row {\r\n  display: grid;\r\n  grid-template-columns: 44px 120px 160px 200px 1fr 128px;\r\n  gap: 16px;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n}\r\n\r\n.lead-col {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 40px;\r\n}\r\n\r\n.lead-col.action {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.lead-col.select {\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.lead-col.select .MuiCheckbox-root {\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.lead-select-all-row {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  padding-bottom: 0px;\r\n  padding-top: 0px;\r\n  gap: 4px;\r\n  min-height: 44px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lead-select-all-label {\r\n  font-size: 14px;\r\n  color: #666;\r\n  font-weight: 500;\r\n  user-select: none;\r\n  cursor: default;\r\n}\r\n\r\n.lead-bulk-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-left: auto;\r\n}\r\n\r\n.lead-bulk-count {\r\n  font-size: 14px;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.lead-export-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 7px 14px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  font-family: inherit;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n.lead-export-button:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n.lead-export-button:disabled {\r\n  background-color: #c7bdf0;\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n.lead-export-icon {\r\n  font-size: 12px;\r\n}\r\n\r\n.lead-bulk-delete-button {\r\n  padding: 5px 10px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  color: #474747;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.lead-bulk-delete-button:hover {\r\n  background-color: #ededed;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.lead-bulk-delete-button:disabled {\r\n  background-color: #ededed;\r\n  transform: scale(1.0);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.lead-bulk-delete-muted {\r\n  color: #c0c0c0;\r\n  border-color: #e8e8e8;\r\n}\r\n\r\n/* Actions area */\r\n.actions-wrap {\r\n  display: inline-flex;\r\n  gap: 12px;\r\n}\r\n\r\n/* Status badge */\r\n.badge {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  font-size: 12px;\r\n  border-radius: 999px;\r\n  border: 1px solid #eaeaea;\r\n  background: #fafafa;\r\n  color: #444;\r\n}\r\n.badge svg { font-size: 10px; }\r\n.badge.unread {\r\n  background: #fff7f7;\r\n  border-color: #ffd9d9;\r\n  color: #c83b3b;\r\n}\r\n.badge.unread svg { color: #ff6b6b; }\r\n.badge.read {\r\n  background: #f3fff7;\r\n  border-color: #c8f1d6;\r\n  color: #187a49;\r\n}\r\n.badge.read svg { color: #2ecc71; }\r\n\r\n/* Date + bot look */\r\n.date {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  color: #3f3f3f;\r\n  font-weight: 500;\r\n}\r\n.date-icon { color: #5616ea; margin-bottom: 2px; }\r\n\r\n.lead-chat-thread .chat-date-separator {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  margin: 4px 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lead-chat-thread .chat-date-separator:first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.lead-chat-thread .chat-date-separator-text {\r\n  background-color: #f0f0f0;\r\n  color: #8e8e8e;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  transition: opacity 0.15s ease;\r\n  opacity: 1;\r\n}\r\n\r\n.bot-pill {\r\n  display: inline-block;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  min-width: 90px;\r\n  text-align: center;\r\n}\r\n\r\n/* lead forwarded during an Agent-Studio test conversation */\r\n.lead-test-pill {\r\n  display: inline-block;\r\n  margin-left: 6px;\r\n  padding: 5px 8px;\r\n  border-radius: 8px;\r\n  background: #fff8f2;\r\n  border: 1px solid #f0c8a8;\r\n  color: #9a4b00;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Param chips */\r\n.lead-param-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px 10px;\r\n}\r\n.param-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  border: 1px solid #ececec;\r\n  background: #fafafa;\r\n  color: #4a4a4a;\r\n  font-size: 12px;\r\n}\r\n.param-chip-icon {\r\n  color: #5616ea;\r\n  font-size: 12px;\r\n}\r\n.param-chip-key { font-weight: 600; }\r\n.param-chip-sep { color: #b7b7b7; }\r\n.param-chip-val { color: #2b2b2b; text-decoration: none; }\r\n\r\n/* Chevron */\r\n.chevron-btn {\r\n  padding: 5px 10px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  color: #474747;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n.chevron-btn:hover {\r\n  background-color: #ededed;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.chevron-btn svg {\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.chevron-btn.expanded svg {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Trash */\r\n.trash-btn {\r\n  padding: 5px 10px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  color: #474747;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n.trash-btn:hover {\r\n  background-color: #ededed;\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* ===== Mirrored chat history (from chatHistoryOverview) ===== */\r\n.lead-chat-thread {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  border-top: 1px solid #eeeeee;\r\n  padding: 14px 16px 16px;\r\n  animation: fadeIn .18s ease;\r\n}\r\n.chat-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 10px;\r\n}\r\n.chat-message:first-child { margin-top: 0; }\r\n.chat-message:last-child { margin-bottom: 0; }\r\n.chat-message.assistant-message { align-items: flex-start; }\r\n.chat-message.user-history-message {\r\n  align-items: flex-end;\r\n  gap: 6px;\r\n}\r\n\r\n.lead-chat-thread .user-message-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 4px;\r\n}\r\n\r\n.lead-chat-thread .user-message-body {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.lead-chat-thread .message-bubble-history {\r\n  padding: 6px 10px !important;\r\n  border-radius: 12px;\r\n  font-size: 15px;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n  background-color: #efefef;\r\n  color: #262626;\r\n}\r\n\r\n.lead-chat-thread .user-history-message .message-bubble-history {\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history {\r\n  background: #efefef;\r\n  color: #262626;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  padding: 6px 10px !important;\r\n  border-radius: 12px 12px 12px 4px;\r\n  max-width: 70%;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history p {\r\n  margin: 0 0 .9em;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history h1,\r\n.lead-chat-thread .assistant-message .message-bubble-history h2,\r\n.lead-chat-thread .assistant-message .message-bubble-history h3,\r\n.lead-chat-thread .assistant-message .message-bubble-history h4,\r\n.lead-chat-thread .assistant-message .message-bubble-history h5,\r\n.lead-chat-thread .assistant-message .message-bubble-history h6 {\r\n  font-size: 1em;\r\n  line-height: inherit;\r\n  margin: 0 0 .9em;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history ul,\r\n.lead-chat-thread .assistant-message .message-bubble-history ol {\r\n  margin: .9em 0;\r\n  padding-left: 1.25em;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history li {\r\n  margin: .25em 0;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history table {\r\n  margin: .9em 0;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history > :first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history > :last-child {\r\n  margin-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-bubble-history a {\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n}\r\n\r\n.lead-chat-thread .user-history-message .message-bubble-history a {\r\n  color: #fff;\r\n}\r\n\r\n.lead-chat-thread .message-bubble-history p {\r\n  margin: 0;\r\n}\r\n\r\n.lead-chat-thread .message-time {\r\n  font-size: 11px;\r\n  color: #8e8e8e;\r\n  padding: 0px;\r\n  margin-bottom: 4px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.lead-chat-thread .assistant-message .message-time {\r\n  align-self: flex-start;\r\n}\r\n\r\n.lead-chat-thread .user-history-message .message-time {\r\n  align-self: flex-end;\r\n}\r\n\r\n.message-bubble {\r\n  padding: 10px 15px;\r\n  border-radius: 10px;\r\n  max-width: 70%;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  word-wrap: break-word;\r\n  background-color: #f6f6f6;\r\n  color: #333;\r\n}\r\n.message-bubble > *:first-child { margin-top: 0; }\r\n.message-bubble > *:last-child { margin-bottom: 0; }\r\n.user-history-message .message-bubble {\r\n  background-color: #5616ea;\r\n  color: #fafafa;\r\n}\r\n.user-history-message .message-bubble a { color: #fafafa; }\r\n\r\n.message-bubble a {\r\n  color: #5616ea;\r\n  text-decoration: underline;\r\n}\r\n.message-bubble table {\r\n  border-collapse: separate;\r\n  border-spacing: 0px;\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n  width: 100%;\r\n  overflow: auto;\r\n  font-size: 14px;\r\n}\r\n.message-bubble th,\r\n.message-bubble td {\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  padding: .35rem .50rem;\r\n  text-align: left;\r\n}\r\n.message-bubble th {\r\n  color: #000000;\r\n  background-color: rgba(0, 0, 0, 0.06);\r\n  padding: .5rem .50rem;\r\n}\r\n.message-bubble th:last-child { border-right: 1px solid rgba(0, 0, 0, 0.08); }\r\n.message-bubble th { border-bottom: none; }\r\n.message-bubble td {\r\n  border-bottom: 0px solid rgba(0, 0, 0, 0.08);\r\n  border-right: 0px solid rgba(0, 0, 0, 0.08);\r\n}\r\n.message-bubble td:last-child { border-right: 1px solid rgba(0, 0, 0, 0.08); }\r\n.message-bubble tr:first-child th:first-child { border-top-left-radius: 8px; }\r\n.message-bubble tr:first-child th:last-child { border-top-right-radius: 8px; }\r\n.message-bubble tr:last-child td:first-child { border-bottom-left-radius: 8px; }\r\n.message-bubble tr:last-child td:last-child { border-bottom-right-radius: 8px; }\r\n.message-bubble tr:last-child td { border-bottom: 1px solid rgba(0,0,0,0.08); }\r\n\r\n/* Empty + Loading */\r\n.leads-empty-min { padding: 16px 0; }\r\n.empty-card {\r\n  border: 1px dashed #dcdcdc;\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  padding: 24px;\r\n  text-align: center;\r\n  color: #555;\r\n}\r\n\r\n.lead-chat-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 24px;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n}\r\n\r\n.lead-chat-empty {\r\n  padding: 24px;\r\n  text-align: center;\r\n  color: #888;\r\n  font-size: 14px;\r\n}\r\n\r\n.lead-pagination {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n  padding: 6px 0 0;\r\n}\r\n\r\n.lead-pagination-summary {\r\n  color: #666;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.lead-pagination-controls {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.lead-page-button {\r\n  min-width: 36px;\r\n  height: 36px;\r\n  padding: 0 10px;\r\n  border: 1px solid #ece7ff;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #742de3;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: 0 8px 16px rgba(94, 27, 255, 0.05);\r\n  transition: background-color 0.25s ease, border-color 0.25s ease, color 0.25s ease, box-shadow 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.lead-page-button:hover:not(:disabled) {\r\n  background: #f9f6ff;\r\n  border-color: #d9ccff;\r\n  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.12);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.lead-page-button.active {\r\n  background: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);\r\n  border-color: #5e1bff;\r\n  color: #fff;\r\n  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.16);\r\n}\r\n\r\n.lead-page-button.active:hover {\r\n  background: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);\r\n  border-color: #5e1bff;\r\n  color: #fff;\r\n  box-shadow: 0 12px 24px rgba(94, 27, 255, 0.16);\r\n  transform: none;\r\n}\r\n\r\n.lead-page-button:disabled {\r\n  background: #f7f7f7;\r\n  border-color: #eeeeee;\r\n  color: #c4c4c4;\r\n  box-shadow: none;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.lead-page-arrow {\r\n  width: 36px;\r\n  padding: 0;\r\n}\r\n\r\n.lead-page-ellipsis {\r\n  min-width: 28px;\r\n  color: #9b8bc8;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0 } to { opacity: 1 }\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 1100px) {\r\n  .lead-row {\r\n    grid-template-columns: 40px 110px 140px 180px 1fr 116px;\r\n  }\r\n}\r\n@media (max-width: 760px) {\r\n  .lead-row {\r\n    grid-template-columns: 36px minmax(0, 1fr) auto;\r\n    grid-template-rows: auto auto auto auto;\r\n    gap: 10px;\r\n    align-items: start;\r\n  }\r\n\r\n  .lead-col.select {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .lead-col.status { grid-column: 2; grid-row: 1; }\r\n  .lead-col.when {\r\n    grid-column: 1 / -1;\r\n    grid-row: 3;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n  }\r\n  .lead-col.bot {\r\n    grid-column: 1 / -1;\r\n    grid-row: 2;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n  .lead-col.action {\r\n    grid-column: 3;\r\n    grid-row: 1;\r\n    justify-content: flex-end;\r\n    align-items: flex-start;\r\n    padding-left: 0;\r\n    padding-right: 6px;\r\n  }\r\n\r\n  .lead-col.params {\r\n    grid-column: 1 / -1;\r\n    grid-row: 4;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    min-width: 0;\r\n  }\r\n\r\n  .lead-param-chips {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    width: 100%;\r\n  }\r\n\r\n  .param-chip {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n    justify-content: flex-start;\r\n    align-self: stretch;\r\n    margin: 0;\r\n    word-break: break-word;\r\n  }\r\n\r\n  .actions-wrap {\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .lead-pagination {\r\n    gap: 12px;\r\n  }\r\n\r\n  .lead-pagination-summary {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .lead-pagination-controls {\r\n    width: 100%;\r\n    gap: 6px;\r\n  }\r\n\r\n  .lead-page-button {\r\n    min-width: 34px;\r\n    height: 34px;\r\n    padding: 0 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
